import {  useState } from "react";
import Modal from "components/ui/modal/modal";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { FaCogs } from "react-icons/fa";
import ParamResultat from "components/app/AuditComplet/SituationPro/ParamResultat";

function ParamResultatEntrePrisePageModal(props) {
  const [modalOpen, setmodalOpen] = useState(false);
  return (
    <>
      <ActionButton 
        onClick={() => setmodalOpen(true)}
        icon={FaCogs}
        title="Paramétrage du résultat"
        style={{maxWidth:'250px'}}
      />
      <Modal
        width="50%"
        height="82%"
        title="Paramétrage du résultat de l'entreprise"
        icon={<FaCogs />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ParamResultat
        Prenom={props.Prenom}
        PrenomConjoint={props.PrenomConjoint}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
    </>
  );
}

export default ParamResultatEntrePrisePageModal;
